/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  Tabs,
  Tab,
  Button,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";

import Add from "@material-ui/icons/Add";
import Delete from "@material-ui/icons/Delete";

import Actions from "../../../fluid/Actions/ActionFactory";

import DataMarker from "./../../../traditional/CreateIC/AddDataDevice/DataMarker/DataMarker";

import { v4 as uuidv4 } from 'uuid';

const clone = require("rfdc")();


const styles = (theme) => ({
  insetTab: {
    borderRight: `1px solid ${theme.palette.divider}`,
    width: "10%",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

class SetWFDataMarkers extends Component {
  state = {
    wf_data_markers: [],
    insetTabValue: 0,

    iu_names: [],
    selected_iu_ws_name: "",

    iu_name_ws_name_map: {},

    iu_names_error: false,
    ws_name_error: false,

    error_text: false,

    submitting: false,
    submit_success: false,
    submit_feedback_text: "",

    loading: false,
  };

  /*
  [{
    "iu_name":"",
    "data_markers":[{},{}]
  }]
  */

  componentDidMount() {
    const headingHeight = this.heading.current.clientHeight;
    const contentHeight = this.props.maxHeight - headingHeight;
    this.setState({
      ...this.state,
      content_height: contentHeight,
      heading_height: headingHeight,
    });
    //make calls for getting IU's under wf
    Actions("http_request", {
      url:
        "/sainapse/workflow/" + this.props.wf_name + "/information_unit_names",
      method: "get",
      data: {},
    })
      .then((res) => {
        console.log("WF - IUs Required: ", res.data.result);

        if (Array.isArray(res.data.result)) {
          let iu_names = res.data.result.map((iu) => iu.value.text);

          //remove duplicate iu_names
          iu_names = [...new Set(iu_names)];
          //initialize wf_data_markers object
          let wfDMs = iu_names.map((iuName) => {
            return {
              iu_name: iuName,
              data_markers: [],
            };
          });
          this.setState({ iu_names: iu_names, wf_data_markers: wfDMs }, () => {
            if (iu_names.length > 0) {
              let firstIUName = iu_names[0];
              //get web service for this IU name
              Actions("http_request", {
                url: `/sainapse/information_channel/${this.props.ic_name}/information_unit/${firstIUName}/webservice`,
                method: "get",
                data: {},
              })
                .then((res) => {
                  console.log("ws name: ", res.data.result);

                  let wsNameForFirstIU = res.data.result.name;
                  this.setState({
                    iu_name_ws_name_map: {
                      ...this.state.iu_name_ws_name_map,
                      [firstIUName]: wsNameForFirstIU,
                    },
                    loading: false,
                  });
                })
                .catch((err) => {
                  this.setState({
                    ...this.state,
                    loading: false,
                    ws_name_error: true,
                    error_text: `Error while fetching web service info for IU ${firstIUName}.`,
                  });
                });
            }
          });
        }
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          loading: false,
          iu_names_error: true,
          error_text: "Error while fetching IU names under the workflow.",
        });
      });
  }

  heading = React.createRef();

  handleInsetTabChange = (event, value) => {
    this.setState(
      {
        ...this.state,
        insetTabValue: value,
        loading: true,
        ws_name_error: false,
        error_text: "",
      },
      () => {
        //get web service for this IU name if already not available in map
        let slctdIUName = this.state.iu_names[this.state.insetTabValue];
        if (this.state.iu_name_ws_name_map[slctdIUName]) {
          this.setState({
            loading: false,
          });
        } else {
          Actions("http_request", {
            url: `/sainapse/information_channel/${
              this.props.ic_name
            }/information_unit/${
              this.state.iu_names[this.state.insetTabValue]
            }/webservice`,
            method: "get",
            data: {},
          })
            .then((res) => {
              console.log("ws name: ", res.data.result);

              let wsName = res.data.result.name;
              this.setState({
                loading: false,
                iu_name_ws_name_map: {
                  ...this.state.iu_name_ws_name_map,
                  [slctdIUName]: wsName,
                },
                ws_name_error: false,
              });
            })
            .catch((err) => {
              this.setState({
                ...this.state,
                loading: false,
                ws_name_error: true,
                error_text: `Error while fetching web service info for IU ${slctdIUName}.`,
              });
            });
        }
      }
    );
  };

  getCrntTabDataMarkers = (dataMarkers) => {
    try {
      if (dataMarkers.length <= 0) return [];
      let dmObjctForCrntTab = dataMarkers.find(
        (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
      );
      if (dmObjctForCrntTab && dmObjctForCrntTab.data_markers) {
        return dmObjctForCrntTab.data_markers;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  renderInsetTabs = () => {
    if (this.state.loading) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="primary" />
        </div>
      );
    } else if (this.state.ws_name_error) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography style={{ color: "#dc014e" }} variant="caption">
            {this.state.error_text}
          </Typography>
        </div>
      );
    } else {
      return (
        <div style={{ padding: "5px", maxHeight: "100%", overflow: "scroll" }}>
          {this.renderTab(
            this.getCrntTabDataMarkers(this.state.wf_data_markers)
          )}
          {this.renderButtons(this.state.insetTabValue)}
        </div>
      );
    }
  };

  renderTab = (selected_tab_data_markers) => {
    let data_markers = selected_tab_data_markers.map((dm, i) => {
      return (
        <DataMarker
          key={dm.id}
          index={i}
          type={this.state.iu_names[this.state.insetTabValue]}
          data_marker={dm}
          ic_name={this.props.ic_name}
          iu_name={this.state.iu_names[this.state.insetTabValue]}
          ws_name={
            this.state.iu_name_ws_name_map[this.state.iu_names[this.state.insetTabValue]]
          }
          edit={true}
          pushDataMarker={(id, data_marker) =>
            this.pushDataMarker(id, data_marker)
          }
          removeDataMarker={(type, id) =>
            this.removeDataMarker(this.state.insetTabValue, type, id)
          }
          editDataMarker={(type, id) =>
            this.editDataMarker(this.state.insetTabValue, type, id)
          }
          field_config = {{
            url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.state.iu_names[this.state.insetTabValue] + '/fields_schema',
            method : "get",
            data : {},
            params : {}
          }}
          operator_config = {{
              url : '/sainapse/web_service/datamarker_operator',
              method : "get",
              data : {},
              params : {
                ws_name : this.state.iu_name_ws_name_map[this.state.iu_names[this.state.insetTabValue]]
              }
          }}
          operator_params_config = {{
              url : '/sainapse/web_service/datamarker_operator/params',
              method : "get",
              data : {},
              params : {
                ws_name : this.state.iu_name_ws_name_map[this.state.iu_names[this.state.insetTabValue]]
              }
          }}
          action_config = {{
              url : '/sainapse/web_service/datamarker_action',
              method : "get",
              data : {},
              params : {
                ws_name : this.state.iu_name_ws_name_map[this.state.iu_names[this.state.insetTabValue]]
              }
          }}
          action_params_config = {{
              url : '/sainapse/web_service/datamarker_action/params',
              method : "get",
              data : {},
              params : {
                ws_name : this.state.iu_name_ws_name_map[this.state.iu_names[this.state.insetTabValue]]
              }
          }}
        />
      );
    });

    return data_markers;
  };

  renderButtons = (tabValue) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ThemeProvider theme={blue_theme}>
          <Tooltip title="Add Data Marker">
            <IconButton
              size="small"
              color="primary"
              onClick={() => this.addDataMarker(tabValue)}
            >
              <Add />
            </IconButton>
          </Tooltip>
        </ThemeProvider>
      </div>
    );
  };

  editDataMarker = (tabValue, type, id) => {
    let new_state = clone(this.state);
    let index = new_state.wf_data_markers
      .find(
        (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
      )
      .data_markers.findIndex((dm) => dm.id === id);
    new_state.wf_data_markers.find(
      (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
    ).data_markers[index].edit = true;
    this.setState({ ...new_state }, () =>
      console.log("Set DM State: ", this.state)
    );
  };

  pushDataMarker = (id, dm) => {
    let new_state = clone(this.state);
    let index = new_state.wf_data_markers
      .find(
        (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
      )
      .data_markers.findIndex((dm) => dm.id === id);
    new_state.wf_data_markers.find(
      (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
    ).data_markers[index] = dm;
    new_state.wf_data_markers.find(
      (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
    ).data_markers[index].edit = false;
    this.setState({ ...new_state }, () =>
      console.log("Set DM State: ", this.state)
    );
  };

  submitDataMarker = () => {
    this.setState({ submitting: true, submit_feedback_text: "" });
    Actions("http_request", {
      url:
        "/sainapse/workflow/" +
        this.props.wf_name +
        "/information_unit_data_markers",

      method: "post",
      data: this.state.wf_data_markers,
    })
      .then((res) => {
        console.log("Submit DM: ", res.data.result);
        this.setState({
          ...this.state,
          submit_success: true,
          submitting: false,
          submit_feedback_text: " Data Marker Submitted succesfully!",
        });
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          submit_success: false,
          submitting: false,
          submit_feedback_text: "Data Marker Submit Failed!",
        });
      });
  };

  areDMsUnderTabReadyToBeSubmitted = (data_markers) => {
    try {
      let num_of_dm = data_markers.length;

      let dm_ready = [];

      for (let i = 0; i < num_of_dm; i++) {
        if (data_markers[i].edit === false) {
          dm_ready[i] = true;
        } else {
          dm_ready[i] = false;
        }
      }

      console.log("DM Ready: ", dm_ready);
      let falsy = dm_ready.filter((item) => item === false);
      console.log("Falsy: ", falsy);
      if (falsy.length === 0 && dm_ready.length !== 0) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  };

  submitEnabled = () => {
    try {
      let isSubmitEnabled = true;

      for (let i = 0; i < this.state.wf_data_markers.length; i++) {
        let datamarkers = this.state.wf_data_markers[i].data_markers;
        if (datamarkers.length === 0) continue;
        let areDMSSubmittable = this.areDMsUnderTabReadyToBeSubmitted(
          datamarkers
        );
        if (!areDMSSubmittable) {
          isSubmitEnabled = false;
          break;
        }
      }
      return isSubmitEnabled;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  addDataMarker = () => {
    let new_state = clone(this.state);
    let new_id = uuidv4()
    new_state.wf_data_markers
      .find(
        (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
      )
      .data_markers.push({
        id: new_id,
        edit: true,
        trigger: {},
        actions: [],
      });

    this.setState({ ...new_state });
  };

  removeDataMarker = (tabValue, type, id) => {
    let new_state = clone(this.state);
    let index = new_state.wf_data_markers
      .find(
        (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
      )
      .data_markers.findIndex((dm) => dm.id === id);
    new_state.wf_data_markers
      .find(
        (val) => val.iu_name === this.state.iu_names[this.state.insetTabValue]
      )
      .data_markers.splice(index, 1);
    this.setState({ ...new_state });
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper elevation={0} square style={{ width: "100%", height: "100%" }}>
        <div style={{ width: "100%", height: "100%" }}>
          <div
            ref={this.heading}
            style={{
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              backgroundColor: "#F0F0F0",
              borderBottom: "1px solid rgba(0,0,0,0.12)",
              padding: "5px",
              width : '100%'
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Typography variant="h6">Set Data Markers</Typography>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                paddingRight: "10px",
                alignItems: "center",
              }}
            >
              <Typography
                style={{
                  color: this.state.submit_success ? "#05AF1A" : "#dc004e",
                  paddingRight: "5px",
                }}
                variant="caption"
              >
                {this.state.submit_feedback_text}
              </Typography>
              <ThemeProvider theme={blue_theme}>
                <Button
                  disabled={!this.submitEnabled()}
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={
                    this.state.submitting ? (
                      <CircularProgress
                        style={{ color: "#FFFFFF" }}
                        size={20}
                      />
                    ) : null
                  }
                  onClick={this.submitDataMarker}
                >
                  Submit Data Marker
                </Button>
              </ThemeProvider>
            </div>
            <ThemeProvider theme={blue_theme}>
              <Button
                style={{ marginLeft: "10px" }}
                size="small"
                variant="contained"
                color="primary"
                onClick={() => this.props.handleNext()}
              >
                {this.state.submit_success ? "Next" : "Skip"}
              </Button>
            </ThemeProvider>
          </div>
          {this.state.iu_names_error ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography style={{ color: "#dc014e" }} variant="caption">
                {this.state.error_text}
              </Typography>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                height: this.state.content_height,
                overflow: "hidden",
              }}
            >
              <div className={classes.insetTab}>
                <ThemeProvider theme={blue_theme}>
                  <Tabs
                    orientation="vertical"
                    value={this.state.insetTabValue}
                    onChange={this.handleInsetTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                  >
                    {this.state.iu_names.map((iuName) => {
                      return <Tab label={iuName}></Tab>;
                    })}
                  </Tabs>
                </ThemeProvider>
              </div>
              <div
                style={{
                  flexGrow: 1,
                  height: "100%",
                  overflow: "hidden",
                  backgroundColor: "#ffffff",
                }}
              >
                {this.renderInsetTabs(this.state.insetTabValue)}
              </div>
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SetWFDataMarkers);
